const notifications = {
  search_contacts: 'Phone / Email',
  report_type: 'Report type',
  failed_payments_report: 'Failed payments report',
  paid_payments_report: 'Paid payments report',
};

export default notifications;
